import { SxProps, Theme } from '@mui/material';

export const imageTendenceSX: SxProps<Theme> = {
	width: '100%',
	objectFit: 'cover',
	height: {
		xs: 'auto',
		sm: '500px',
	},
};
